if (!customElements.get('trapt-bundle-builder')) {
  customElements.define(
    'trapt-bundle-builder',
    class TraptBundleBuilder extends HTMLElement {
      constructor() {
        super();
        this.selectedCount = 1;
        this.items = [];
        this.draftItems = [];
        this.activeSlot = 0;
        this.busy = false;
      }

      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.currentProduct = this.parseJson(this.querySelector('[data-current-product]'));
        this.dialog = this.querySelector('[data-bundle-dialog]');
        this.sizeDialog = this.querySelector('[data-size-dialog]');
        this.slotsContainer = this.querySelector('[data-bundle-slots]');
        this.summary = this.querySelector('[data-bundle-summary]');
        this.applyButton = this.querySelector('[data-bundle-apply]');
        this.pickerError = this.querySelector('[data-bundle-picker-error]');
        this.form = document.getElementById(this.dataset.productFormId);
        this.productForm = this.form ? this.form.closest('product-form') : null;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.productForm ? this.productForm.querySelector('[type="submit"]') : null;
        this.buyNowButton = this.closest('product-info')?.querySelector('[data-trapt-buy-now]');
        this.sizeOpenButtons = [...(this.closest('product-info')?.querySelectorAll('[data-trapt-size-open]') || [])];

        this.onClickBound = this.onClick.bind(this);
        this.onChangeBound = this.onChange.bind(this);
        this.onKeydownBound = this.onKeydown.bind(this);
        this.onFormSubmitBound = this.onFormSubmit.bind(this);
        this.onBuyNowBound = () => this.addItems(true);
        this.onSizeOpenBound = () => this.openDialog(this.sizeDialog);
        this.onDialogCloseBound = () => {
          if (!this.querySelector('dialog[open]')) document.body.classList.remove('overflow-hidden');
        };

        // The tier prices are rendered from the variant that happened to be first.
        // Keep them on the size the shopper actually has selected.
        this.onVariantChangeBound = () => {
          clearTimeout(this.variantSyncTimer);
          this.variantSyncTimer = setTimeout(() => this.syncTierPrices(), 120);
        };
        this.productInfo = this.closest('product-info');
        if (this.productInfo) this.productInfo.addEventListener('change', this.onVariantChangeBound);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChangeBound);
        }
        this.syncTierPrices();

        this.addEventListener('click', this.onClickBound);
        this.addEventListener('change', this.onChangeBound);
        this.addEventListener('keydown', this.onKeydownBound);
        if (this.form) this.form.addEventListener('submit', this.onFormSubmitBound, true);
        if (this.buyNowButton) this.buyNowButton.addEventListener('click', this.onBuyNowBound);
        this.sizeOpenButtons.forEach((button) => button.addEventListener('click', this.onSizeOpenBound));
        [this.dialog, this.sizeDialog].forEach((dialog) => dialog?.addEventListener('close', this.onDialogCloseBound));
      }

      disconnectedCallback() {
        clearTimeout(this.variantSyncTimer);
        if (this.productInfo) this.productInfo.removeEventListener('change', this.onVariantChangeBound);
        if (typeof this.variantUnsubscribe === 'function') this.variantUnsubscribe();
        this.removeEventListener('click', this.onClickBound);
        this.removeEventListener('change', this.onChangeBound);
        this.removeEventListener('keydown', this.onKeydownBound);
        if (this.form) this.form.removeEventListener('submit', this.onFormSubmitBound, true);
        if (this.buyNowButton) this.buyNowButton.removeEventListener('click', this.onBuyNowBound);
        this.sizeOpenButtons?.forEach((button) => button.removeEventListener('click', this.onSizeOpenBound));
        [this.dialog, this.sizeDialog].forEach((dialog) => dialog?.removeEventListener('close', this.onDialogCloseBound));
        delete this.dataset.initialized;
      }

      parseJson(script) {
        if (!script) return null;
        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.error('TRAPT bundle product data could not be read.', error);
          return null;
        }
      }

      onClick(event) {
        const headingTrigger = event.target.closest('[data-bundle-heading-trigger]');
        if (headingTrigger && this.contains(headingTrigger)) {
          this.toggleHeadingMenu();
          return;
        }

        const headingCount = event.target.closest('[data-bundle-heading-count]');
        if (headingCount && this.contains(headingCount)) {
          const count = Number.parseInt(headingCount.dataset.bundleHeadingCount, 10);
          this.toggleHeadingMenu(false);
          if (count === 1) {
            this.selectSingle();
            this.closeDialog(this.dialog);
          } else {
            this.resizeDraft(count);
          }
          return;
        }

        if (!event.target.closest('[data-bundle-heading-menu]')) this.toggleHeadingMenu(false);

        const tier = event.target.closest('[data-bundle-count]');
        if (tier && this.contains(tier)) {
          const count = Number.parseInt(tier.dataset.bundleCount, 10);
          if (count === 1) this.selectSingle();
          if (count === 2 || count === 3) this.openPicker(count);
          return;
        }

        const tab = event.target.closest('[data-bundle-tab]');
        if (tab && this.contains(tab)) {
          this.activateTab(tab.dataset.bundleTab);
          return;
        }

        const slotButton = event.target.closest('[data-bundle-slot]');
        if (slotButton && this.contains(slotButton)) {
          this.activeSlot = Number.parseInt(slotButton.dataset.bundleSlot, 10);
          this.renderSlots();
          return;
        }

        const quantityButton = event.target.closest('[data-bundle-quantity-action]');
        if (quantityButton && this.contains(quantityButton)) {
          const card = quantityButton.closest('[data-bundle-product-card]');
          const product = this.parseJson(card?.querySelector('[data-bundle-product-json]'));
          if (product) this.adjustProductQuantity(product, quantityButton.dataset.bundleQuantityAction);
          return;
        }

        const productButton = event.target.closest('[data-bundle-product-button]');
        if (productButton && this.contains(productButton)) {
          const product = this.parseJson(productButton.closest('.t98731-picker__product')?.querySelector('[data-bundle-product-json]'));
          if (product) this.chooseProduct(product);
          return;
        }

        if (event.target.closest('[data-bundle-apply]')) {
          this.applyDraft();
          return;
        }

        if (event.target.closest('[data-bundle-close], [data-bundle-cancel]')) {
          this.closeDialog(this.dialog);
          return;
        }

        if (event.target.closest('[data-size-close]')) {
          this.closeDialog(this.sizeDialog);
          return;
        }

        if (event.target.closest('[data-trapt-size-open]')) {
          this.openDialog(this.sizeDialog);
        }
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        const options = this.querySelector('[data-bundle-heading-options]');
        if (!options || options.hidden) return;
        event.stopPropagation();
        this.toggleHeadingMenu(false);
        this.querySelector('[data-bundle-heading-trigger]')?.focus();
      }

      onChange(event) {
        const optionControl = event.target.closest('[data-bundle-option]');
        if (!optionControl || !this.contains(optionControl)) return;

        const slotIndex = Number.parseInt(optionControl.dataset.slotIndex, 10);
        const optionIndex = Number.parseInt(optionControl.dataset.optionIndex, 10);
        const selection = this.draftItems[slotIndex];
        if (!selection) return;

        selection.optionValues[optionIndex] = optionControl.value;
        selection.variant = this.findVariant(selection.product, selection.optionValues);
        this.renderSlots();
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '${{amount}}';
        const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!placeholder) return format;
        const withDelimiters = (precision, thousands, decimal) => {
          const amount = (Number(cents) / 100).toFixed(precision);
          const parts = amount.split('.');
          const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
          return parts[1] ? whole + decimal + parts[1] : whole;
        };
        let value;
        switch (placeholder[1]) {
          case 'amount_no_decimals':
            value = withDelimiters(0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            value = withDelimiters(2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = withDelimiters(0, '.', ',');
            break;
          default:
            value = withDelimiters(2, ',', '.');
        }
        return format.replace(placeholder[0], value);
      }

      /* Percentage off a set of three, from the block setting. */
      discountPercent(count) {
        const percent = Number.parseFloat(this.dataset.setDiscount);
        if (!Number.isFinite(percent) || percent <= 0) return 0;
        return count >= 3 ? percent : 0;
      }

      currentUnitPrice() {
        const variants = Array.isArray(this.currentProduct?.variants) ? this.currentProduct.variants : [];
        if (!variants.length) return null;
        const id = this.currentVariantId();
        const variant =
          variants.find((candidate) => Number(candidate.id) === Number(id)) ||
          variants.find((candidate) => candidate.available) ||
          variants[0];
        return typeof variant?.price === 'number' ? variant.price : null;
      }

      /* What a set of this size actually costs. Once the frames have been
         chosen they carry their own sizes and prices — a small and a large is
         not two of whatever the buy box happens to be showing — so the real
         selection wins over the estimate. */
      tierGrossTotal(count) {
        const chosen = this.items.length === count ? this.items : null;
        if (chosen) {
          const total = chosen.reduce((sum, selection) => sum + (Number(selection.variant?.price) || 0), 0);
          if (total > 0) return total;
        }
        const unit = this.currentUnitPrice();
        return unit === null ? null : unit * count;
      }

      netTotal(gross, count) {
        const percent = this.discountPercent(count);
        if (!percent) return gross;
        return Math.round((gross * (100 - percent)) / 100);
      }

      priceMarkup(gross, count) {
        const net = this.netTotal(gross, count);
        if (net === gross) return this.escape(this.formatMoney(gross));
        return `<s class="t98731-bundle__tier-was">${this.escape(this.formatMoney(gross))}</s> ${this.escape(this.formatMoney(net))}`;
      }

      syncTierPrices() {
        const prices = [...this.querySelectorAll('[data-bundle-tier-price]')];
        if (!prices.length) return;
        prices.forEach((node) => {
          const count = Number.parseInt(node.dataset.bundleTierPrice, 10) || 1;
          /* A multi-frame tier only carries a price once the frames are chosen:
             until then the sizes are unknown and any figure would be a guess. */
          const known = count === 1 || this.items.length === count;
          if (!known) {
            node.textContent = '';
            return;
          }
          const gross = this.tierGrossTotal(count);
          if (gross === null) return;
          node.innerHTML = this.priceMarkup(gross, count);
        });
      }

      /* The running total inside the picker, so a mixed set is never a surprise. */
      syncDraftTotal() {
        const node = this.querySelector('[data-bundle-total]');
        if (!node) return;
        const chosen = this.draftItems.filter((selection) => typeof selection?.variant?.price === 'number');
        if (!chosen.length) {
          node.hidden = true;
          return;
        }
        const gross = chosen.reduce((sum, selection) => sum + selection.variant.price, 0);
        const complete = chosen.length === this.draftCount;
        const percent = complete ? this.discountPercent(this.draftCount) : 0;
        const net = percent ? Math.round((gross * (100 - percent)) / 100) : gross;
        const label = complete ? 'Set total' : `${chosen.length} of ${this.draftCount} chosen`;
        const off = percent ? ` <span class="t98731-picker__total-off">${percent}% off</span>` : '';
        const was = percent ? `<s>${this.escape(this.formatMoney(gross))}</s> ` : '';
        node.innerHTML = `<span class="t98731-picker__total-label">${this.escape(label)}</span> ${was}<strong>${this.escape(this.formatMoney(net))}</strong>${off}`;
        node.hidden = false;
      }

      currentVariantId() {
        const input = this.form?.querySelector('[name="id"]');
        return input ? Number.parseInt(input.value, 10) : null;
      }

      selectionFromProduct(product, preferredVariantId = null) {
        if (!product || !Array.isArray(product.variants)) return null;
        const preferred = product.variants.find((variant) => Number(variant.id) === Number(preferredVariantId) && variant.available);
        const variant = preferred || product.variants.find((candidate) => candidate.available);
        if (!variant) return null;
        return { product, optionValues: [...variant.options], variant };
      }

      findVariant(product, optionValues) {
        if (!product || !Array.isArray(product.variants)) return null;
        return product.variants.find(
          (variant) => variant.available && variant.options.every((value, index) => value === optionValues[index])
        ) || null;
      }

      selectSingle() {
        this.selectedCount = 1;
        this.items = [];
        this.setTierState(1);
        this.summary.textContent = '1 frame selected';
        this.syncTierPrices();
      }

      openPicker(count) {
        const currentSelection = this.selectionFromProduct(this.currentProduct, this.currentVariantId());
        if (this.selectedCount === count && this.items.length === count) {
          this.draftItems = this.items.map((selection) => ({
            product: selection.product,
            optionValues: [...selection.optionValues],
            variant: selection.variant,
          }));
        } else {
          this.draftItems = Array.from({ length: count }, (_, index) => (index === 0 ? currentSelection : null));
        }

        this.draftCount = count;
        this.activeSlot = this.draftItems.findIndex((selection) => !selection);
        if (this.activeSlot < 0) this.activeSlot = 0;
        this.setHeadingCountState(count);
        this.setPickerError('');
        this.renderSlots();
        this.openDialog(this.dialog);
      }

      chooseProduct(product) {
        const selection = this.selectionFromProduct(product);
        if (!selection) {
          this.setPickerError('This product has no available options right now.');
          return;
        }

        this.draftItems[this.activeSlot] = selection;
        const nextEmpty = this.draftItems.findIndex((candidate, index) => index > this.activeSlot && !candidate);
        if (nextEmpty >= 0) this.activeSlot = nextEmpty;
        this.setPickerError('');
        this.renderSlots();
      }

      adjustProductQuantity(product, action) {
        const productId = String(product.id);
        const matchingSlots = this.draftItems.reduce((matches, selection, index) => {
          if (selection && String(selection.product.id) === productId) matches.push(index);
          return matches;
        }, []);

        if (action === 'minus') {
          const slotIndex = matchingSlots[matchingSlots.length - 1];
          if (slotIndex === undefined) return;
          this.draftItems[slotIndex] = null;
          this.activeSlot = slotIndex;
          this.setPickerError('');
          this.renderSlots();
          return;
        }

        const emptySlot = this.draftItems.findIndex((selection) => !selection);
        if (emptySlot < 0) {
          this.setPickerError(`Your ${this.draftCount}-frame set is full. Remove a frame before adding another.`);
          return;
        }

        const selection = this.selectionFromProduct(product);
        if (!selection) {
          this.setPickerError('This product has no available options right now.');
          return;
        }

        this.draftItems[emptySlot] = selection;
        const nextEmpty = this.draftItems.findIndex((candidate) => !candidate);
        this.activeSlot = nextEmpty >= 0 ? nextEmpty : emptySlot;
        this.setPickerError('');
        this.renderSlots();
      }

      resizeDraft(count) {
        if (count !== 2 && count !== 3) return;
        if (count > this.draftItems.length) {
          this.draftItems = this.draftItems.concat(Array(count - this.draftItems.length).fill(null));
        } else if (count < this.draftItems.length) {
          this.draftItems = this.draftItems.slice(0, count);
        }
        this.draftCount = count;
        this.setHeadingCountState(count);
        const firstEmpty = this.draftItems.findIndex((selection) => !selection);
        this.activeSlot = firstEmpty >= 0 ? firstEmpty : Math.min(this.activeSlot, count - 1);
        this.setPickerError('');
        this.renderSlots();
      }

      setHeadingCountState(count) {
        const label = this.querySelector('[data-bundle-heading-label]');
        if (label) label.textContent = `${count} ${count === 1 ? 'frame' : 'frames'}`;
        this.querySelectorAll('[data-bundle-heading-count]').forEach((button) => {
          const selected = Number.parseInt(button.dataset.bundleHeadingCount, 10) === count;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-selected', String(selected));
        });
      }

      toggleHeadingMenu(force) {
        const trigger = this.querySelector('[data-bundle-heading-trigger]');
        const options = this.querySelector('[data-bundle-heading-options]');
        if (!trigger || !options) return;
        const open = typeof force === 'boolean' ? force : options.hidden;
        options.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
      }

      renderSlots() {
        if (!this.slotsContainer) return;
        this.slotsContainer.innerHTML = this.draftItems.map((selection, index) => this.slotMarkup(selection, index)).join('');
        this.syncDraftTotal();
        const complete = this.draftItems.length === this.draftCount && this.draftItems.every((selection) => selection?.variant?.available);
        if (this.applyButton) this.applyButton.disabled = !complete;
        this.updateProductCardStates();
      }

      updateProductCardStates() {
        const counts = this.draftItems.reduce((result, selection) => {
          if (!selection) return result;
          const productId = String(selection.product.id);
          result.set(productId, (result.get(productId) || 0) + 1);
          return result;
        }, new Map());
        const setIsFull = this.draftItems.length > 0 && this.draftItems.every(Boolean);

        this.querySelectorAll('[data-bundle-product-card]').forEach((card) => {
          const count = counts.get(String(card.dataset.bundleProductId)) || 0;
          card.classList.toggle('is-added', count > 0);
          card.querySelector('[data-bundle-added]')?.toggleAttribute('hidden', count === 0);
          const quantity = card.querySelector('[data-bundle-product-quantity]');
          if (quantity) quantity.hidden = count === 0;
          const value = card.querySelector('[data-bundle-quantity-value]');
          if (value) value.textContent = String(count);
          const minus = card.querySelector('[data-bundle-quantity-action="minus"]');
          if (minus) minus.disabled = count === 0;
          const plus = card.querySelector('[data-bundle-quantity-action="plus"]');
          if (plus) plus.disabled = setIsFull;
        });
      }

      productImage(product) {
        const featured = product?.featured_image;
        if (typeof featured === 'string') return featured;
        if (featured?.src) return featured.src;
        return product?.featured_media?.preview_image?.src || product?.images?.[0] || '';
      }

      variantImage(variant) {
        const featured = variant?.featured_image;
        if (typeof featured === 'string') return featured;
        return featured?.src || '';
      }

      /* The first variant carrying this option value decides the swatch art. */
      optionImage(product, optionIndex, value) {
        const variants = Array.isArray(product?.variants) ? product.variants : [];
        const match = variants.find((variant) => variant.options?.[optionIndex] === value && this.variantImage(variant));
        return match ? this.variantImage(match) : '';
      }

      sizedImage(url, width) {
        if (!url) return '';
        try {
          const parsed = new URL(url, window.location.origin);
          parsed.searchParams.set('width', String(width));
          return parsed.toString();
        } catch (error) {
          return url;
        }
      }

      slotMarkup(selection, index) {
        const activeClass = index === this.activeSlot ? ' is-active' : '';
        if (!selection) {
          return `<section class="t98731-slot t98731-slot--empty${activeClass}">
            <button class="t98731-slot__select" type="button" data-bundle-slot="${index}">
              <span class="t98731-slot__index">Frame ${index + 1}</span>
              <span class="t98731-slot__empty">Choose a product</span>
            </button>
          </section>`;
        }

        const optionNames = Array.isArray(selection.product.options) ? selection.product.options : [];
        const optionsMarkup = optionNames.map((name, optionIndex) => {
          const values = [...new Set(selection.product.variants.map((variant) => variant.options[optionIndex]))];
          const groupName = `BundleOption-${this.dataset.sectionId}-${index}-${optionIndex}`;
          const valueImages = values.map((value) => this.optionImage(selection.product, optionIndex, value));
          /* Only options whose values really look different get swatches: size shares one photo, background does not. */
          const asSwatches = values.length > 1
            && valueImages.every(Boolean)
            && new Set(valueImages).size === values.length;
          const choices = values.map((value, valueIndex) => {
            const id = `${groupName}-${valueIndex}`;
            const checked = value === selection.optionValues[optionIndex] ? ' checked' : '';
            const input = `<input id="${id}" type="radio" name="${groupName}" value="${this.escape(value)}" data-bundle-option data-slot-index="${index}" data-option-index="${optionIndex}"${checked}>`;
            if (!asSwatches) {
              return `${input}<label for="${id}">${this.escape(value)}</label>`;
            }
            return `${input}<label class="t98731-slot__swatch" for="${id}">
              <span class="t98731-slot__swatch-media"><img src="${this.escape(this.sizedImage(valueImages[valueIndex], 160))}" alt="" width="80" height="80" loading="lazy" decoding="async"></span>
              <span class="t98731-slot__swatch-label">${this.escape(value)}</span>
            </label>`;
          }).join('');
          return `<fieldset class="t98731-slot__option${asSwatches ? ' t98731-slot__option--swatches' : ''}">
            <legend>${this.escape(name)}</legend>
            <div class="t98731-slot__choices">${choices}</div>
          </fieldset>`;
        }).join('');

        const availability = selection.variant ? '' : '<p class="t98731-picker__error">That option combination is unavailable.</p>';
        const imageUrl = this.variantImage(selection.variant) || this.productImage(selection.product);
        const imageMarkup = imageUrl
          ? `<img src="${this.escape(this.sizedImage(imageUrl, 240))}" alt="" loading="lazy" width="120" height="150">`
          : '<span class="t98731-slot__media-placeholder" aria-hidden="true"></span>';
        return `<section class="t98731-slot${activeClass}">
          <button class="t98731-slot__select" type="button" data-bundle-slot="${index}" aria-expanded="${index === this.activeSlot}">
            <span class="t98731-slot__media">${imageMarkup}</span>
            <span class="t98731-slot__copy">
              <span class="t98731-slot__index">Frame ${index + 1} · Edit</span>
              <span class="t98731-slot__product">${this.escape(selection.product.title)}</span>
              <span class="t98731-slot__variant">${selection.optionValues.map(value => this.escape(value)).join(" · ")}</span>
              ${typeof selection.variant?.price === 'number' ? `<span class="t98731-slot__price">${this.escape(this.formatMoney(selection.variant.price))}</span>` : ''}
            </span>

          </button>
          <div class="t98731-slot__options">${optionsMarkup}</div>
          ${availability}
        </section>`;
      }

      applyDraft() {
        const complete = this.draftItems.length === this.draftCount && this.draftItems.every((selection) => selection?.variant?.available);
        if (!complete) {
          this.setPickerError('Choose an available product and options for every frame.');
          return;
        }

        this.items = this.draftItems.map((selection) => ({
          product: selection.product,
          optionValues: [...selection.optionValues],
          variant: selection.variant,
        }));
        this.selectedCount = this.draftCount;
        this.setTierState(this.selectedCount);
        const names = this.items.map((selection) => selection.product.title).join(', ');
        this.summary.textContent = `${this.selectedCount} frames selected: ${names}`;
        this.syncTierPrices();
        this.closeDialog(this.dialog);
      }

      setTierState(count) {
        this.querySelectorAll('[data-bundle-count]').forEach((button) => {
          const selected = Number.parseInt(button.dataset.bundleCount, 10) === count;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      }

      activateTab(handle) {
        this.querySelectorAll('[data-bundle-tab]').forEach((tab) => {
          const active = tab.dataset.bundleTab === handle;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        this.querySelectorAll('[data-bundle-panel]').forEach((panel) => {
          const active = panel.dataset.bundlePanel === handle;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }

      onFormSubmit(event) {
        if (this.selectedCount === 1) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addItems(false);
      }

      cartItems() {
        if (this.selectedCount === 1) {
          const variantId = this.currentVariantId();
          return variantId ? [{ id: variantId, quantity: 1 }] : [];
        }
        return [...this.items.reduce((lines, selection) => {
          const variantId = Number(selection.variant.id);
          const line = lines.get(variantId) || { id: variantId, quantity: 0 };
          line.quantity += 1;
          lines.set(variantId, line);
          return lines;
        }, new Map()).values()];
      }

      async addItems(checkout) {
        if (this.busy) return;
        const items = this.cartItems();
        const itemCount = items.reduce((total, item) => total + item.quantity, 0);
        if (itemCount !== this.selectedCount) {
          this.showPurchaseError('Please finish choosing every frame.');
          return;
        }

        this.busy = true;
        this.setPurchaseLoading(true);
        this.showPurchaseError('');

        try {
          const payload = { items };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          const response = await fetch(routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'These frames could not be added.');

          if (checkout) {
            const root = window.Shopify?.routes?.root || '/';
            window.location.assign(`${root}checkout`);
            return;
          }

          if (this.cart) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'trapt-bundle-builder', cartData: data });
            }
            this.cart.renderContents(data);
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
          }
        } catch (error) {
          this.showPurchaseError(error.message || 'These frames could not be added. Please try again.');
        } finally {
          this.busy = false;
          this.setPurchaseLoading(false);
        }
      }

      setPurchaseLoading(loading) {
        [this.submitButton, this.buyNowButton].forEach((button) => {
          if (!button) return;
          button.toggleAttribute('aria-disabled', loading);
          button.classList.toggle('loading', loading);
        });
        const spinner = this.submitButton?.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !loading);
      }

      showPurchaseError(message) {
        const wrapper = this.productForm?.querySelector('.product-form__error-message-wrapper');
        const text = wrapper?.querySelector('.product-form__error-message');
        if (!wrapper || !text) return;
        wrapper.toggleAttribute('hidden', !message);
        text.textContent = message;
      }

      setPickerError(message) {
        if (!this.pickerError) return;
        this.pickerError.hidden = !message;
        this.pickerError.textContent = message;
      }

      openDialog(dialog) {
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      }

      closeDialog(dialog) {
        if (!dialog) return;
        if (dialog === this.dialog) this.toggleHeadingMenu(false);
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
        if (!this.querySelector('dialog[open]')) document.body.classList.remove('overflow-hidden');
      }

      escape(value) {
        return String(value ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');
      }
    }
  );
}
